export default __webpack_public_path__ + "static/media/cio.c1a200c5.png";